{
  "tabs": {
    "chat": "Chat",
    "reminders": "Lembretes",
    "calendar": "Calendario",
    "settings": "Axustes"
  },
  "common": {
    "cancel": "Cancelar",
    "save": "Gardar",
    "confirm": "Confirmar",
    "delete": "Eliminar",
    "back": "Voltar",
    "close": "Pechar",
    "edit": "Editar",
    "search": "Buscar",
    "all": "Todo",
    "loading": "Cargando...",
    "error": "Algo fallou",
    "notFound": "Non atopado",
    "tryAgain": "Por favor, tenta de novo",
    "retry": "Reintentar",
    "undo": "Desfacer",
    "pullToRefresh": "Puxe para actualizar",
    "justNow": "agora mesmo"
  },
  "auth": {
    "welcome": "Benvido a FishMemory",
    "tagline": "O teu asistente de recordatorios de WhatsApp, agora no teu peto.",
    "subtitle": "O teu asistente de recordatorios de WhatsApp, agora no teu peto.",
    "phoneLabel": "O teu número de WhatsApp",
    "phoneHint": "Enviarémosche un código de verificación por WhatsApp",
    "invalidPhone": "Por favor, introduce un número válido",
    "continue": "Continuar",
    "enterPhone": "Introduce o teu número de WhatsApp",
    "phonePlaceholder": "Número de teléfono",
    "sendCode": "Enviar código",
    "verifyTitle": "Verifica o teu número",
    "otpSentTo": "Enviouse un código de 6 díxitos a {{phone}} por WhatsApp",
    "enterFullCode": "Por favor, introduce os 6 díxitos",
    "invalidOtp": "Código inválido. Por favor, tenta de novo.",
    "otpFailed": "Erro ao enviar o código. Tenta de novo.",
    "otpResent": "Código reenviado",
    "resendIn": "Reenviar en {{seconds}}s",
    "resendCode": "Reenviar código",
    "enterOtp": "Introduce o código enviado ao teu WhatsApp",
    "verify": "Verificar",
    "resend": "Reenviar código",
    "wrongNumber": "Número incorrecto?",
    "backToPhone": "Voltar ao teléfono",
    "editPhone": "Editar número",
    "error": "Erro",
    "setupTitle": "Imos configurar",
    "setupSubtitle": "Podes cambiar isto máis tarde en Axustes",
    "namePlaceholder": "O teu nome",
    "letsGo": "Rematar configuración",
    "skipForNow": "Pular por agora"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Escribe unha mensaxe...",
    "inputPlaceholder": "Escribe unha mensaxe...",
    "typing": "FishMemory está escribindo...",
    "online": "En liña",
    "connecting": "Conectando...",
    "reconnecting": "Reconectando...",
    "offline": "Fóra de liña",
    "empty": "Comeza unha conversa",
    "emptyHint": "Crea recordatorios, consulta a túa axenda ou pide axuda.",
    "emptyAction": "Enviar un recordatorio de exemplo",
    "actions": "Accións do chat",
    "keep": "Conservar mensaxes",
    "clearTitle": "Limpar chat",
    "clearConfirm": "Eliminar todas as mensaxes deste dispositivo? Non se pode desfacer.",
    "clear": "Limpar chat",
    "optionSelected": "Seleccionado: {{label}}",
    "sendingSelection": "Enviando...",
    "connectionLost": "Reconectando..."
  },
  "reminders": {
    "title": "Os meus recordatorios",
    "active": "Activos",
    "today": "Hoxe",
    "thisWeek": "Esta semana",
    "history": "Historial",
    "items": "elementos",
    "emptyTitle": "Sen recordatorios aínda",
    "emptySubtitle": "Crea un desde o chat e aparecerá aquí.",
    "emptyAction": "Abrir chat",
    "filterActive": "Activos",
    "filterToday": "Hoxe",
    "filterWeek": "Esta semana",
    "filterHistory": "Historial",
    "emptyState": "Sen recordatorios aínda. Comeza a chatear!",
    "swipeDone": "Feito",
    "swipeSnooze": "Adiar",
    "swipeDelete": "Eliminar",
    "search": "Buscar recordatorios...",
    "upcoming": "Próximos",
    "completed": "Completados",
    "overdue": "Atrasados",
    "tomorrow": "Mañá",
    "synced": "Sincronizado {{value}}",
    "swipeHint": "Desliza un recordatorio para máis accións",
    "noResults": "Ningún recordatorio coincide coa busca",
    "noResultsHint": "Proba outra palabra ou limpa a busca",
    "deleteAllFailed": "Erro ao eliminar todos os recordatorios"
  },
  "calendar": {
    "title": "Calendario",
    "today": "Hoxe",
    "tomorrow": "Mañá",
    "completed": "feito",
    "noEvents": "Nada programado",
    "noEventsSubtitle": "Escolla unha data para ver recordatorios e eventos.",
    "googleEvent": "Google Calendar",
    "legendActive": "Activo",
    "legendRecurring": "Recurrente",
    "legendDone": "Feito",
    "legendGoogle": "Google",
    "previousMonth": "Mes anterior",
    "nextMonth": "Mes seguinte",
    "previousYear": "Ano anterior",
    "nextYear": "Ano seguinte",
    "goToToday": "Ir a hoxe",
    "all": "Todo",
    "active": "Activo",
    "done": "Feito",
    "paused": "Pausado"
  },
  "settings": {
    "title": "Axustes",
    "profile": "Perfil",
    "name": "Nome a mostrar",
    "enterName": "Introduce o teu nome",
    "language": "Idioma",
    "uiLanguage": "Idioma da app",
    "uiLanguageHelp": "Cambia a interface, etiquetas do calendario e dirección só neste dispositivo.",
    "serverLanguage": "Idioma do chat",
    "serverLanguageHelp": "Cambia o idioma das respostas do servidor e mensaxes para a túa conta.",
    "timezone": "Fuso horario",
    "currentTimezone": "Fuso horario actual",
    "timezoneHelp": "Todos os horarios dos recordatorios móstranse neste fuso.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Gardar fuso",
    "timezoneSaved": "Fuso actualizado",
    "detect": "Detectar",
    "detectFailed": "Non se puido detectar o fuso",
    "autoDetect": "Detectar automaticamente por GPS",
    "notifications": "Notificacións",
    "notificationsHelp": "Os recordatorios de seguimento controlan alertas repetidas tras entregarse un recordatorio. Os permisos de notificación do dispositivo xéstanse nas configuracións do teléfono.",
    "pushEnabled": "Notificacións Push",
    "autoDoneOnFire": "Marcar feito ao disparar",
    "autoDoneOnFireDesc": "Se está desactivado, os recordatorios permanecen activos ata que os marques feitos.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Conectado",
    "googleDisconnected": "Non conectado",
    "googleConnectedHelp": "Os novos recordatorios poden sincronizarse automaticamente co teu calendario.",
    "googleDisconnectedHelp": "Conecta Google Calendar para manter os recordatorios e eventos sincronizados.",
    "googleConnectFailed": "Erro ao conectar Google Calendar",
    "connected": "Conectado",
    "disconnected": "Non conectado",
    "connect": "Conectar",
    "disconnect": "Desconectar",
    "autoSync": "Sincronizar novos recordatorios",
    "autosync": "Sincronizar novos recordatorios",
    "subscription": "Subscripción",
    "trialUsed": "Proba: {{used}}/{{total}} usada",
    "trialStatus": "Proba dispoñible",
    "activeStatus": "Subscripción activa",
    "expiredStatus": "Subscripción expirada",
    "unsubscribedStatus": "Non subscrito",
    "about": "Acerca de",
    "version": "Versión",
    "logout": "Pechar sesión",
    "logoutTitle": "Pechar sesión",
    "logoutConfirm": "Seguro que queres pechar sesión?",
    "noName": "Sen nome",
    "serverConnection": "Conexión ao servidor",
    "serverUrl": "URL do servidor",
    "serverEdit": "Editar",
    "saveReconnect": "Gardar e reconectar",
    "resetDefault": "Restablecer por defecto",
    "invalidServerUrlTitle": "URL do servidor inválida",
    "invalidServerUrlMessage": "Introduce unha URL válida http ou https, por exemplo https://example.com",
    "uiLanguageChangeFailed": "Erro ao cambiar o idioma da app. Por favor, tenta de novo.",
    "serverLanguageChangeFailed": "Erro ao cambiar o idioma do chat. Por favor, tenta de novo.",
    "timezoneChangeFailed": "Erro ao cambiar o fuso horario. Por favor, tenta de novo.",
    "autoSyncChangeFailed": "Erro ao actualizar a sincronización automática. Por favor, tenta de novo.",
    "nameChangeFailed": "Erro ao actualizar o nome a mostrar. Por favor, tenta de novo.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalles do recordatorio",
    "editTime": "Editar hora",
    "rename": "Renomear",
    "snooze": "Adiar",
    "snooze15": "Adiar 15 minutos",
    "pause": "Pausar",
    "pauseReminder": "Pausar recordatorio",
    "resume": "Continuar",
    "resumeReminder": "Continuar recordatorio",
    "skip": "Saltar seguinte",
    "skipOccurrence": "Saltar esta ocorrencia",
    "syncGoogle": "Sincronizar con Google",
    "delete": "Eliminar",
    "deleteTitle": "Eliminar recordatorio",
    "deleteConfirm": "Este recordatorio eliminarase permanentemente.",
    "deleteRecurringTitle": "Eliminar recordatorio recurrente",
    "deleteRecurringMessage": "Queres saltar esta ocorrencia ou eliminar toda a serie?",
    "deleteThisOccurrence": "Saltar esta ocorrencia",
    "deleteEntireSeries": "Eliminar toda a serie",
    "done": "Feito",
    "markDone": "Marcar como feito",
    "undo": "Restaurar",
    "undoPrompt": "Precisas que estea activo de novo? Restaura agora.",
    "recurring": "Recurrente",
    "nextRun": "Próxima execución",
    "oneTime": "Unha vez",
    "pending": "Pendiente",
    "sent": "Enviado",
    "paused": "Pausado",
    "active": "Activo",
    "snoozed": "Adiado",
    "localTime": "Mostrado na túa hora local",
    "recurrence": "Recurrencia",
    "created": "Creado",
    "tags": "Etiquetas",
    "fireCount": "Vezes activado",
    "actions": "Accións",
    "none": "Ningunha",
    "snoozeFailed": "Erro ao adiar recordatorio",
    "pauseFailed": "Erro ao pausar recordatorio",
    "resumeFailed": "Erro ao continuar recordatorio",
    "skipFailed": "Erro ao saltar recordatorio",
    "doneFailed": "Erro ao marcar recordatorio como feito",
    "undoFailed": "Erro ao restaurar estado do recordatorio",
    "deleteFailed": "Erro ao eliminar recordatorio",
    "rescheduleTitle": "Reprogramar?",
    "rescheduleMsg": "Este recordatorio está atrasado. Queres reprogramalo?",
    "reschedule15": "En 15 minutos",
    "reschedule60": "En 1 hora",
    "keepOverdue": "Manter como está"
  },
  "onboarding": {
    "slide1Title": "Benvido a FishMemory",
    "slide1Sub": "O teu asistente persoal de recordatorios — con WhatsApp e feito para o teu peto.",
    "slide2Title": "Só chatea naturalmente",
    "slide2Sub": "Escribe recordatorios como pensas: \"Lémbrame chamar á mamá mañá ás 3pm\" — nós encargámonos do resto.",
    "slide3Title": "Nunca perdas nada",
    "slide3Sub": "Recibe notificacións a tempo, organiza con etiquetas e mantente ao día do que importa.",
    "getStarted": "Comezar",
    "next": "Seguinte",
    "firstReminderTitle": "Crea o teu primeiro recordatorio!",
    "firstReminderHint": "Proba a escribir algo como:",
    "firstReminderExample": "Lémbrame beber auga mañá ás 9 AM",
    "gotIt": "Entendido!",
    "notifRationaleTitle": "Mantente a tempo",
    "notifRationaleBody": "FishMemory necesita notificacións para lembrarte a tempo. Só recibirás alertas dos recordatorios que crees.",
    "notifRationaleAllow": "Activar notificacións",
    "notifRationaleLater": "Quizais máis tarde",
    "swipeHint": "Desliza á dereita para accións rápidas →",
    "calendarDragHint": "Arrastra para expandir ↕"
  }
}
